@if (!dismissed()) {
  @if (headingText() || subtitle()) {
    <div class="hx-note__header" [style.max-width]="validatedWidth()">
      @if (headingText()) {
        <div
          class="hx-note__title"
          id="note-title"
          [style.font-weight]="labelFontWeightStyle()"
          [style.font-style]="labelFontStyle()"
          [style.text-decoration]="labelTextDecoration()"
          [style.font-size]="labelFontSizeStyle()"
          [style.color]="labelColor()">
          {{ headingText() }}
          @if (tooltip()) {
            <hx-icon
              fontIcon="info-circle"
              size="16"
              [class]="'hx-label__tooltip-icon hx-label__tooltip-icon--color-' + tooltipColor()"
              [hxTooltip]="tooltip()!"
              [position]="tooltipPosition()"
              [tooltipColor]="tooltipColor()"
              [style.margin-left]="'8px'"
              [style.vertical-align]="'middle'"
              [style.cursor]="'pointer'"></hx-icon>
          }
        </div>
      }
      @if (subtitle()) {
        <div
          class="hx-note__subtitle"
          id="note-subtitle"
          [style.font-weight]="subtitleFontWeightStyle()"
          [style.font-style]="subtitleFontStyle()"
          [style.text-decoration]="subtitleTextDecoration()"
          [style.font-size]="subtitleFontSizeStyle()"
          [style.color]="subtitleColor()">
          {{ subtitle() }}
        </div>
      }
    </div>
  }

  <div
    aria-atomic="true"
    aria-live="polite"
    class="hx-note__container"
    role="alert"
    tabindex="-1"
    [attr.aria-describedby]="'note-description'"
    [attr.aria-labelledby]="headingText() ? 'note-title' : null"
    [style.max-width]="validatedWidth()"
    [style.background-color]="backgroundColor()"
    [style.color]="backgroundColor() ? '#000000' : null"
    (keydown)="handleKeyDown($event)">
    <div class="hx-note__content">
      <div class="hx-note__description ql-snow" id="note-description">
        <div
          class="ql-editor"
          noteRichContent
          [innerHTML]="sanitizedHtml()"
          [style.text-align]="contentJustification()"></div>
      </div>

      <div class="hx-note__actions">
        <ng-content />
      </div>
    </div>

    @if (dismissible()) {
      <button #closeButton aria-label="Close note" class="hx-note__close" type="button" (click)="handleDismiss()">
        <span aria-hidden="true" class="hx-note__close-icon">×</span>
      </button>
    }
  </div>
}
